import PositionAssignmentTabView from '@src/main/modules/reports/ui/components/PositionAssignmentTabView';
import PunctualityView from '@src/main/modules/reports/ui/components/PunctualityView';
import { FC } from 'react';

interface ReportsTabContentProps {
  activeIndex: number;
  className?: string;
}

const ReportsTabContent: FC<ReportsTabContentProps> = ({ activeIndex, className }) => {
  const getContent = () => {
    switch (activeIndex) {
      case 0:
        return <PunctualityView key="NB" formType="NB" />;
      case 1:
        return <PunctualityView key="WB" formType="WB" />;
      case 2:
        return <PositionAssignmentTabView key="OB" />;
      default:
        return null;
    }
  };

  return <div className={className}>{getContent()}</div>;
};

export default ReportsTabContent;
